import API from './API.js';
export default class Ac_qualifications extends API {
    constructor() {
        super('ac_qualifications');
    }

}
